import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const UpdateSummary = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateSummaryV2,
        method: RequestType.POST,
        data,
    });

const GetSummaryList = (params: any) =>
    request({
        url: ApiURL.Command.GetSummaryListV2,
        method: RequestType.GET,
        params,
    });

const AxaptaTransferSummary = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.AxaptaTransferSummaryV2,
        method: RequestType.POST,
        data,
    });

const SummaryCommandV2 = {
    UpdateSummary,
    GetSummaryList,
    AxaptaTransferSummary,
};

export default SummaryCommandV2;
